import React from "react";

import { useResetPassword } from "./useResetPassword.hook";
import { Error } from "../../_common/Error";
import { SuccessMessage } from "../../_common/SuccessMessage";

export function ResetPassword({ match }) {
  const { token } = match.params;

  const {
    isLoading,
    successMessage,
    error,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    handleSubmit,
  } = useResetPassword({
    token,
  });

  return (
    <form className="tw-space-y-6" onSubmit={handleSubmit} method="post">

      {error && <Error message={error} />}
      {successMessage && <SuccessMessage message={successMessage} />}
      
      <div>
        <label htmlFor="password" className="w-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Password</label>
        <div>
          <input
            className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
            type="password"
            autoComplete="off"
            name="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="password-1"
          />
        </div>
      </div>
      <div>
        <label htmlFor="cpassword" className="w-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Confirm Password</label>
        <div>
          <input
            className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
            type="password"
            autoComplete="off"
            name="cpassword"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            data-testid="password-2"
          />
        </div>
      </div>
      <button className="tw-flex tw-w-full tw-rounded-md tw-bg-blue-500 tw-justify-center tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-text-white tw-shadow-xs hover:tw-bg-blue-400 focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-blue-500" 
        type="submit" disabled={isLoading}>
        {isLoading ? "Loading..." : "Reset Password"}
      </button>
    </form>
  );
}
